import { PASSPORT_CLIENT, CLIENT_ACCOUNT } from '../baseURL'
import axios from '../config'

export default {
  //登录授权
  auth(payload) {
    const { username, password } = payload
    return axios.get(`${PASSPORT_CLIENT}/auth?username=${username}&password=${password}`, payload)
  },
  //验证token有效性
  verifyToken(token) {
    return axios.get(`${PASSPORT_CLIENT}/auth/verify`, {
      headers: { 'Authorization': 'Bearer ' + token }
    })
  },
  //注册
  register(Phone, Password) {
    return axios.post(`${CLIENT_ACCOUNT}/user/register`, {
      Name: Phone, NickName: Phone, Password,
    })
  },
  //检查是否在小程序中
  checkInMiniProgram() {
    return new Promise(resolve => {
      if (-1 === navigator.userAgent.toLowerCase().indexOf('micromessenger')) {
        resolve(false)
        return
      }

      const miniProgram = window.wx && window.wx.miniProgram;
      if (!miniProgram || typeof miniProgram.getEnv !== 'function') {
        resolve(false)
        return
      }

      let settled = false;
      const finish = value => {
        if (settled) return;
        settled = true;
        resolve(value)
      };
      const timer = setTimeout(() => finish(false), 3000);

      try {
        miniProgram.getEnv(res => {
          clearTimeout(timer);
          finish(!!res?.miniprogram)
        })
      } catch (error) {
        clearTimeout(timer);
        finish(false)
      }
    })
  }
}
